import { useContext, useEffect, useState } from 'react';
import ClienteContext from 'context/ClienteContext';
import Swal from "sweetalert2";
import {
    getAll,
    getVinculedClientsWithDirection,
    desvinculedClient,
    vinculedClient,
    getVinculedClientsWithEmail,
    desvinculedClientOfEmail,
    vinculedClientToEmail,
} from "services/ClienteService.js";

let itemsPerPage = 5;
let totalPages;

export function useCliente() {
    const [page, setPage] = useState(1);
    

    const {
        allClientes,
        setAllClientes,
        clientes,
        vinculedClientes,
        setVinculedClientes,
        setClientes,
        message,
        setMessage,
        loading,
        setLoading
    } = useContext(ClienteContext);

    const likeClient = async ({direccion, cliente}) => {
        const idDireccion = direccion._id;
        const idCliente = cliente._id;
        setLoading(true);
        try {
            const {message} = await vinculedClient({idDireccion, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.mail;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const unlikeClient = async ({direccion, cliente}) => {
        const idDireccion = direccion._id;
        const idCliente = cliente._id
        setLoading(true);
        try {
            const {message} = await desvinculedClient({idDireccion, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.mail;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }
    
    const getVinculedClients = async ({direccion, mail}) => {
        const idDireccion = direccion._id;
        setLoading(true);
        try {
            const response = await getVinculedClientsWithDirection({idDireccion, mail});
            setVinculedClientes(response);
            setLoading(false);
            return response
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const getAllClientes = async ({ name, mail, numDocument }) => {
        try {
            const response = await getAll({ name, mail, numDocument });
            setAllClientes(response)
            return response
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
        }
    }

    const getClientes = async ({ page = 1, name, mail, numDocument }) => {
        setLoading(true);
        setPage(page);
        try {
            const allClientes = await getAllClientes({ name, mail, numDocument });
            setAllClientes(allClientes);
            totalPages = Math.ceil(allClientes.length / itemsPerPage)
            const clientes = await getAll({ page, limit: itemsPerPage, name, mail, numDocument });
            setClientes(clientes);
            setLoading(false);
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const likeClientToEmail = async ({email, cliente}) => {
        const idEmail = email._id;
        const idCliente = cliente._id;
        setLoading(true);
        try {
            const {message} = await vinculedClientToEmail({idEmail, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.numDocument;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const unlikeClientOfEmail = async ({email, cliente}) => {
        const idEmail = email._id;
        const idCliente = cliente._id
        setLoading(true);
        try {
            const {message} = await desvinculedClientOfEmail({idEmail, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.numDocument;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const getVinculedClientsOfEmail = async ({email, numDocument}) => {
        const idEmail = email._id;
        setLoading(true);
        try {
            const response = await getVinculedClientsWithEmail({idEmail, numDocument});
            setVinculedClientes(response);
            setLoading(false);
            return response
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    useEffect(() => {
        getClientes({});
        // eslint-disable-next-line
    }, [])

    return {allClientes, clientes, page, totalPages, status: message.status, loading, getClientes, setPage, vinculedClientes, getVinculedClients, unlikeClient, likeClient, getVinculedClientsOfEmail, unlikeClientOfEmail, likeClientToEmail}
}